import { Outlet } from 'react-router-dom';
import { MicroservicesProviders } from './app/providers/MicroservicesProviders';

/**
 * Host integration shell: scoped providers + module styles, no duplicate sidebar.
 * Renders inside DashboardRoot's main content area.
 */
export function MicroservicesShell() {
  return (
    <MicroservicesProviders>
      <div className="microservices-module h-full min-h-0">
        <Outlet />
      </div>
    </MicroservicesProviders>
  );
}
